import {Pipe, PipeTransform} from '@angular/core';
import {ContactPermission} from '../model/contact-permission.enum';

@Pipe({ name: 'mobileUse' })
export class MobileUsePipe implements PipeTransform {

  private pathToLabel = 'PERSONAL_DATA.PERSONAL_INFORMATION.PERSONAL_INFORMATION_CONTACTINFO.';

  /**
   * @example
   * <div class="value editable">{{mobileContactPermission | mobileUse | translate }}</div>
   * @param mobileContactPermission
   * @returns {string} The path to the right mobile use message
   */
  transform(mobileContactPermission: ContactPermission): string {
    if (!mobileContactPermission) {
      return undefined;
    }
    switch (mobileContactPermission) {
      case ContactPermission.ALL: {
        return this.pathToLabel + 'phone_all';
      }
      case ContactPermission.P: {
        return this.pathToLabel + 'phone_personal';
      }
      default: {
        return this.pathToLabel + 'phone_none';
      }
    }
  }
}
